<template>
  <div v-for="row in excludedAccessories" :key="row.title" class="mb-24">
    <ContentRow headingTag="h3" :labels="row.labels" :title="row.title">
      <component :is="row.icon" aria-hidden="true"></component>
    </ContentRow>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import ContentRow from '@backmarket/nuxt-layer-product-modals/ContentRow.vue'
import { IconChargingWire as DSIconChargingWire } from '@ds/icons/IconChargingWire'
import { IconQuality as DSIconQuality } from '@ds/icons/IconQuality'
import { IconWarning as DSIconWarning } from '@ds/icons/IconWarning'

import type { GetAccessoryExclusionsResponse } from '~/api/product-page/types'

const ICONS: Record<string, unknown> = {
  IconChargingWire: DSIconChargingWire,
  IconQuality: DSIconQuality,
  IconWarning: DSIconWarning,
}

const props = defineProps<{
  accessoryExclusions: GetAccessoryExclusionsResponse
}>()

const excludedAccessories = computed(() => {
  return props.accessoryExclusions.paragraphs.map(
    ({
      icon,
      title,
      text,
    }: GetAccessoryExclusionsResponse['paragraphs'][number]) => ({
      icon: ICONS[icon],
      labels: [text],
      title,
    }),
  )
})
</script>
